import { ColDef } from 'ag-grid-community';

import { WorkflowTab } from '@/components/common';

import { outsideEmbryosColumns } from './columns';
import { shipmentTabEmbryoColumnDefs } from './columns/shipments';

export type TabRoute =
  | 'embryos'
  | 'shipping-integration'
  | 'ivf-transit-embryos'
  | 'outside-embryos';

export type ButtonAction =
  | 'add-to-shipment'
  | 'location-change'
  | 'embryo-check-in'
  | 'add-outside-embryos'
  | 'add-missing-straws'
  | 'add-implant-embryos';

export const tabRoutes: TabRoute[] = [
  'embryos',
  'shipping-integration',
  'ivf-transit-embryos',
  'outside-embryos',
];

export const tabNames = [
  'Embryo Inventory',
  'Shipping Integration',
  'IVF Transit Embryos',
  'Outside Embryos',
];

export const workflowTabs: WorkflowTab<TabRoute>[] = [
  {
    key: 'embryos',
    label: 'Embryo Inventory',
    icon: 'pi pi-database',
  },
  {
    key: 'shipping-integration',
    label: 'Shipping Integration',
    icon: 'pi pi-send',
  },
  {
    key: 'ivf-transit-embryos',
    label: 'IVF Transit Embryos',
    icon: 'pi pi-directions',
  },
  {
    key: 'outside-embryos',
    label: 'Outside Embryos',
    icon: 'pi pi-box',
  },
];

export const tabConfig = [
  {
    route: 'embryos',
    name: 'Embryo Inventory',
    columnDefs: [] as ColDef[],
    storageKey: 'embryo-app-grid',
    gridClassName: 'embryo-app',
    buttons: [
      {
        label: 'Add to Shipment',
        icon: 'pi pi-arrow-right',
        action: 'add-to-shipment' as const,
      },
      {
        label: 'Location Change',
        icon: 'pi pi-sort-alt',
        action: 'location-change' as const,
      },
    ],
  },
  {
    route: 'shipping-integration',
    name: 'Shipping Integration',
    columnDefs: shipmentTabEmbryoColumnDefs,
    storageKey: 'shipping-embryo-grid',
    gridClassName: 'shipping-embryo-app',
    buttons: [],
  },
  {
    route: 'ivf-transit-embryos',
    name: 'IVF Transit Embryos',
    columnDefs: [] as ColDef[],
    storageKey: 'ivf-transit-embryo-app-grid',
    gridClassName: 'ivf-transit-embryo-app',
    buttons: [
      {
        label: 'Location Change',
        icon: 'pi pi-sort-alt',
        action: 'location-change' as const,
      },
    ],
  },
  {
    route: 'outside-embryos',
    name: 'Outside Embryos',
    columnDefs: outsideEmbryosColumns,
    storageKey: 'outside-embryo-app-grid',
    gridClassName: 'outside-embryo-app',
    buttons: [
      {
        label: 'Add Missing Straws',
        icon: 'pi pi-plus',
        action: 'add-missing-straws' as const,
      },
      {
        label: 'Add Missing Implant Embryos',
        icon: 'pi pi-plus',
        action: 'add-implant-embryos' as const,
      },
      {
        label: 'Add Outside Embryos',
        icon: 'pi pi-plus',
        action: 'add-outside-embryos' as const,
      },
    ],
  },
];
